import React, { useState, useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import "./InputField.scss";
import { onChangeEvent } from "../reactive-events/onChange";

const Input = props => {
  const { name, label, errortext } = props;
  const [value, setValue] = useState("");

  const dispatch = useDispatch();
  const formObj = useSelector(({ form }) => form[form.currentForm], shallowEqual);

  const onChange = e => {
    setValue(e.target.value);
    dispatch(onChangeEvent(name, e.target.value))
  };

  useEffect(() => {
    let defVal = formObj && formObj.hasOwnProperty(name) ? formObj[name] : "";
    setValue(defVal);
  }, [name, formObj]);

  return (
    <div style={{ gridArea: name }}>
      <p className={`sisp-label ${!props.hasOwnProperty("required") ? "sisp-input--required" : ""}`}>{label}</p>
      <input value={value && value.value? value.value: value} onChange={onChange} required {...props}></input>
      <p className="sisp-input-helper">{errortext || ""}</p>
    </div>
  );
};

export default React.memo(Input);
